import { EditOrganizationRequest, OrgDto, useUpdateOrganizationMutation } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useCreateEditor, useSaveNow } from "../../../common/editing/save-coordinator";
import { useAppDispatch } from "../../../common/redux/hooks";
import { updateSelectedOrg } from "../../../common/redux/reducers/authStateReducer";

export const useCreateOrganizationEditor = (): void => {
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const dispatch = useAppDispatch();
  const [editOrg] = useUpdateOrganizationMutation();
  useCreateEditor<OrgDto, EditOrganizationRequest>(selectedOrg.id, {
    initialState: selectedOrg,
    save: async (fields) => {
      const updated = await editOrg({ orgId: selectedOrg.id, editOrganizationRequest: fields }).unwrap();
      dispatch(updateSelectedOrg(updated));
      return updated;
    },
  });
};

export const useSaveOrganization = (): {
  saveOrganization: (patch: EditOrganizationRequest) => Promise<void>;
  isSaving: boolean;
} => {
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const { saveNow, isSaving } = useSaveNow<OrgDto, EditOrganizationRequest>(selectedOrg.id);
  return { saveOrganization: saveNow, isSaving };
};
